import React, {Component} from "react";
import {Link} from "react-router-dom";
import HeaderRight from "../layouts/HeaderRight";
import {post} from './../../networking/Api'
import Constent from './../../networking/Constent';
import helpers from './../../networking/Helpers';
import {Alert} from "./../../alertServices";
import { withTranslation } from 'react-i18next';
import moment from 'moment';
import CheckinPopup from "../timeregistration/CheckinPopup";

class ShiftUser extends Component {
    constructor(props) {
        super(props);
        this.state={
            absences: [],
          data_list:[],
          all_shift_data:[],
          group_list:[],
          user_list: [],
          selected_user:'',
          selected_user_ary : [],
          group_id: '*',
          date:helpers.getCurrentDate(),
          user_id:'',
          name:'',
          image:process.env.PUBLIC_URL + '/assets/img/placeholder.png',
          total_shift: -1,
          total_all_shift: -1,
          total_hour: '00:00',

          shift_id: '',
          day:'',
         
          schema_id : '',
          assignment_list : [],
          assignment_id : '',
          assignment_color:'#ced4da',
          start:'',
          end:'',
          note:'',
          overtime:'',salary_amt:'',salary_type:2,
          is_publish:1,
          breaks:'',
          shareholders: [
           {    from_time:"",
                to_time: ""
          }],
          shift_type : 'my_shift'
        }
        this.handleChange = this.handleChange.bind(this);  
    }
    componentDidMount(){
        localStorage.setItem('temp_data', JSON.stringify([]));
        var userID = (localStorage.getItem('user_type') !== 'user') ? this.props.match.params.id : localStorage.getItem('userid');
        this.setState({user_id:userID, selected_user:this.props.match.params.id});
        this.setState({date:helpers.getCurrentDate()});
        this.getUserShift();
        this.getContactList();
    }
    
    addOpenShiftId(checed){
        this.setState({is_open_shift: checed});
        // --- first remove duplication value
        var mySet = new Set(this.state.selected_user_ary);
        var myArr = [...mySet];

        if(checed === true){
            this.setState({
                selected_user_ary: myArr.concat(0)
            });
        }else{
            this.setState({
                selected_user_ary: this.state.selected_user_ary.filter(function(selecteduser) { 
                return selecteduser !== 0 
            })});
        }
    }

    handleChange(event) {
        var isChecked = event.target.checked;  
        var id = event.target.value;  
        
        var tempdata = JSON.parse(localStorage.getItem('temp_data'));
        if(isChecked){
            tempdata =  tempdata.concat(id);

        }else{
            var array = tempdata; // make a separate copy of the array
            var index = array.indexOf(id)
            if (index !== -1) {
                array.splice(index, 1);
            }
            tempdata = array;
        }
        localStorage.setItem('temp_data',  JSON.stringify(tempdata));
        this.setState({selected_user_ary:tempdata});
    } 

    handleCheckSelectedUserExistOrNot(val) {
        return this.state.selected_user_ary.some(item => val == item);
    }

    removeMultiUserId(id){
        var tempdata = JSON.parse(localStorage.getItem('temp_data'));
        var array = tempdata; // make a separate copy of the array
        var index = array.indexOf(id.toString());
        if (index !== -1) {
            array.splice(index, 1);
        }
        tempdata = array;
        localStorage.setItem('temp_data',  JSON.stringify(tempdata));
        this.setState({selected_user_ary:tempdata});
    }

    handleAddShareholder = () => {
      this.setState({
        shareholders: this.state.shareholders.concat([ 
          { 
            from_time:"",
            to_time: ""
          }])
      });
    };
    handleRemoveShareholder = idx => () => {
      this.setState({
        shareholders: this.state.shareholders.filter((s, sidx) => idx !== sidx)
      });
    };
    handleShareholderNameChange = idx => evt => {
        const newShareholders = this.state.shareholders.map((shareholder, sidx) => {
        if (idx !== sidx) return shareholder;
        return { ...shareholder, from_time: evt.target.value };
      });
  
      this.setState({ shareholders: newShareholders });
    };
    handleShareholderNameChange1 = idx => evt => {
      const newShareholders = this.state.shareholders.map((shareholder, sidx) => {
        if (idx !== sidx) return shareholder;
        return { ...shareholder, to_time: evt.target.value };
      });
      this.setState({ shareholders: newShareholders });
    };

    getUserShift(){
      var formData=new FormData();
      var userId = (localStorage.getItem('user_type') !== 'user') ? this.props.match.params.id : localStorage.getItem('userid');
      formData.append("user_id",userId);
      post(Constent.GETUSERSHIFT,formData).then(response=>{
          if(response.status===1){
            this.setState({
                absences: response.absence,
                data_list:response.usershift,
                name:response.user_details.full_name,
                image:response.user_details.image,
                total_shift:response.usershift.length,
                total_hour:'00:00',
            })
          }
      })
    }

    getAllShif(date){
      var formData=new FormData();
      var userId = (localStorage.getItem('user_type') !== 'user') ? this.props.match.params.id : localStorage.getItem('userid');
      formData.append("department_id",localStorage.getItem('department_id'));
      formData.append("date",date);
      formData.append("user_id", userId);
      formData.append("schema_child_id",'main_schema');
      post(Constent.GETDEPSHIFT,formData).then(response=>{
          if(response.status===1){
            this.setState({
                date:date,
                absences: response.absences,
                all_shift_data:response.usershift,
                total_all_shift:response.usershift.length
            });
          }
      })
    }

    getContactList(){
        var user_id= localStorage.getItem('userid');
        var formData = new FormData();
        formData.append("user_id",user_id);
        post(Constent.CONTACT,formData).then(response=>{
          if(response.status){
           this.setState({user_list:response.user_list});
           this.getAssignment();       
          }else{
            Alert.error({title: response.message});
          }
        })
    }
    
    getAssignment(){
        var formData=new FormData();
        formData.append("department_id",localStorage.getItem('department_id'))
        post(Constent.SHIFT,formData).then(response=>{
               if(response.status===1){
                this.setState({assignment_list:response.assignments});
            }
        })
    }

    addShift(){
        var schema_id = (localStorage.getItem('schema_id') === null) ? '' : localStorage.getItem("schema_id");
          var formData =new FormData();
          formData.append("department_id",localStorage.getItem('department_id'));
          formData.append("schema_id",schema_id);
          formData.append("assignment_id",this.state.assignment_id);
          formData.append("user_id",this.state.selected_user_ary);
          formData.append("start",this.state.date+" "+this.state.start);
          formData.append("end",this.state.date+" "+this.state.end);
          formData.append("notes",this.state.note);
          formData.append("overtime",this.state.overtime);
          formData.append("salary_amt",this.state.salary_amt);
          formData.append("salary_type",this.state.salary_type);
          formData.append("is_publish",( (this.state.is_publish === true) || (this.state.is_publish === 1) ? 1 : 0));
          formData.append("breaks",this.state.shareholders);
          post(Constent.ADDSHIFT,formData).then(response=>{
            if(response.status===1){
                window['modalClose']();
              this.getUserShift(this.state.date);
              Alert.success({title: response.message});
              localStorage.setItem('temp_data', JSON.stringify([]));
              this.setState({user_id:'',start:'',end:'',note:'',overtime:'',salary_amt:'',salary_type:'',is_publish:1,breaks:''});
            }else{
              Alert.error({title: response.message});
            }
        })
    }

     updateShift(){
        var schema_id = (localStorage.getItem('schema_id') === null) ? '' : localStorage.getItem("schema_id");
          var formData =new FormData();
          formData.append("shift_id",this.state.shift_id);
          formData.append("schema_id",schema_id);
          formData.append("assignment_id",this.state.assignment_id);
          formData.append("user_id",this.state.selected_user_ary);
          formData.append("start",this.state.date+" "+this.state.start);
          formData.append("end",this.state.date+" "+this.state.end);
          formData.append("notes",this.state.note);
          formData.append("overtime",this.state.overtime);
          formData.append("salary_amt",this.state.salary_amt);
          formData.append("salary_type",this.state.salary_type);
          formData.append("is_publish",( (this.state.is_publish === true) || (this.state.is_publish === 1) ? 1 : 0));
          formData.append("breaks",this.state.shareholders);
          post(Constent.UPDATESHIFT,formData).then(response=>{
            if(response.status===1){
                window['modalClose']();
                this.getUserShift();                
                Alert.success({title: response.msg});
                localStorage.setItem('temp_data', JSON.stringify([]));
                this.setState({shift_id:'',user_id:'',start:'',end:'',note:'',overtime:'',salary_amt:'',salary_type:'',is_publish:1,breaks:''});
            }else{
              Alert.error({title: response.message});
            }
        })
    }

    deleteShift(){
        var formData=new FormData();
        formData.append("shift_id",this.state.shift_id)
        formData.append("user_id",localStorage.getItem("userid"))
        post(Constent.DELETESHIFT,formData).then(response=>{
            if(response.status===1){
                window['modalClose']();
                this.getUserShift();
                Alert.success({title: response.message});
            }else{
                Alert.error({title: response.message});
            }
        })
    }

    deleteAbsence(absence_id){
        var formData=new FormData();
        formData.append("absence_id", absence_id)
        post(Constent.DELETE_USER_ABSENCE, formData).then(response=>{
            if(response.status === 1){
                let _absences = this.state.absences;
                _absences = _absences.filter((absence) => {
                    return absence.absence_id != absence_id;
                })
                this.setState({absences: _absences})
                Alert.success({title: response.msg});
            }else{
                Alert.error({title: response.msg});
            }
        })
    }

    freeShift(){
        var formdata=new FormData();
        formdata.append("user_id",localStorage.getItem("userid"));
        formdata.append("event_id",this.state.shift_id);
        post(Constent.FREESHIFT,formdata).then(response =>{
        if(response.status===1){
            window['modalClose']();
            this.getUserShift();
            Alert.success({title: response.msg});
        } else {
            Alert.error({title: response.msg});
        }
    
        })
    };

    handleChangeSalary = key => (event, value) => {
      this.setState({
        salary_type: value
      });
    };

    applyFreeShift(){
        let user_id= localStorage.getItem('userid');
        var formdata=new FormData();
        formdata.append("user_id",user_id);
        formdata.append("event_id",this.state.shift_id);
        post(Constent.APPLYFREESHIFT,formdata).then(response =>{
            if(response.status===1){
              window['modalClose']();
              this.getUserShift();
              Alert.success({title: response.msg});
            } else{
                Alert.error({title: response.msg});
            }
        })
    };

    selectDropdown = (val) => {
        this.setState({shift_type:val});
        if(val === 'my_shift'){
            this.getUserShift();
        }else{
            this.getAllShif(this.state.date);
        }
    };

    handelPreviousShift(date){
        var new_date = moment(date, "YYYY-MM-DD").subtract('days', 1).format("YYYY-MM-DD");
        this.getAllShif(new_date);
    }
    
    handelNextShift(date){
        var new_date = moment(date, "YYYY-MM-DD").add(1, "days").format("YYYY-MM-DD");;
        this.getAllShif(new_date);
    }

    changeCheckIn = (checkInStatus) => {
        this.setState({checkInStatus: checkInStatus});
    }
    
    render() {
        const { t } = this.props;
        return (
            <>
            <div className="header-area shift-userpage" style={{'borderRadius': 0}}>
                    <div className="container">
                        <div className="row">
                            <div className="col-sm-3 col-3">
                                <Link className="menu-back-page home-clicked" to={'/'}>
                                    <i className="fa fa-home" />
                                </Link>
                            </div>
                            <div className="col-sm-6 col-6 text-center">
                                <div className="page-name">{t('lang.menu_name_shift_schedule')}</div>
                            </div>
                            <div className="col-sm-3 col-3 text-right">
                               <HeaderRight />
                            </div>
                        </div>
                    </div>
                </div>

                <div className={(localStorage.getItem('user_type') === 'user') ? 'mg-top-30 shift-userpage sub-header' : 'mg-top-50 shift-userpage sub-header' }>
                    <div className="row action-row">
                        {(localStorage.getItem('user_type') !== 'user') ? 
                        <div className="row action-row">
                            <div className="col-12 text-overflow">
                                <img src={this.state.image} alt="img" />
                                <div className="fullname text-overflow">
                                   { this.state.name }
                                </div>
                            </div>
                        </div> : ''
                    }
                    </div>
                </div>
                {(localStorage.getItem('user_type') === 'user') ? 
                <>
                 {(this.state.shift_type === 'all_shift') ? 
                    <div className="timeregistraion-userlistpage page-title">
                        <div className="calendar-day text-center">
                          <table style={{width:'100%'}}>
                          <tbody>
                            <tr>
                              <td><Link to={'#'} className="link-underline" onClick={()=>{this.getAllShif(helpers.getCurrentDate())}} >{t('lang.shift_sc_today')} </Link></td>  
                              <td onClick={()=>{this.handelPreviousShift(this.state.date)}}><i className="la la-angle-left"></i></td>
                              <td>{moment(this.state.date, "YYYY-MM-DD").format("dddd")} <br></br>{moment(this.state.date, "YYYY-MM-DD").format("DD/MM/YYYY")}</td>
                              <td onClick={()=>{this.handelNextShift(this.state.date)}}><i className="la la-angle-right"></i></td>
                              <td className="datecalanderDiv">
                                <i className="las la-calendar" data-toggle="modal" data-target="#calendar-modal"></i>
                              </td>
                            </tr>
                            </tbody>
                          </table>
                    </div>
                </div> : ''}
                    <select className="form-control" style={{background:'#E6E6E6',broder:'1px solid #CCCCCC',paddingLeft: 20}}
                    value={this.state.shift_type}
                    onChange={e => { this.selectDropdown(e.target.value)}}>
                        <option value="my_shift" key={Math.random()} >{t('lang.shift_sc_my_shift')}</option>
                        <option value="all_shift" key={Math.random()}>{t('lang.shift_sc_department_shift')}</option>
                    </select> </>:''}

                
                <div className={(this.state.shift_type === 'my_shift') ? 'shift-userpage transaction-area mg-bottom-40' : 'shift-userlistpage transaction-area mg-bottom-40'}>
                {(this.state.shift_type === 'my_shift') ?        
                        <div style={{marginTop:20}}>
                            {this.state.total_shift < 0 ? <p className="text-center">{t('lang.common_text_loading') }</p> : '' }
                            {this.state.total_shift === 0 ? <p className="text-center"> {t('lang.shift_sc_no_shift_available')}</p> : '' }
                            {this.state.data_list.map(({ status, date,user_id,assignment_id,shift_id,day, start,end, name,color, notes,is_apply,breaks ,is_publish, overtime, salary_amt,salary_type}) => (
                            <div key={Math.random()}>
                            { (status === 'day') && (user_id !== -1) ? 
                            <div className={(user_id === 0) ? 'single-goal-free' : 'single-goal'}  >
                                <Link to={'#'} 
                                data-toggle="modal" data-target={(localStorage.getItem('user_type') !== 'user') ? '#edit-shift-modal' :'#apply-shift-modal' }
                                onClick={()=>{
                                  this.setState({
                                    user_id : user_id,
                                    is_publish:is_publish,
                                    shift_id : shift_id,
                                    selected_user : user_id,
                                    assignment_id : assignment_id,
                                    assignment_color: color,
                                    start:start,
                                    end:end,
                                    day : day,
                                    note:notes,
                                    breaks:breaks,
                                    overtime: overtime,
                                    salary_amt:salary_amt,
                                    salary_type:salary_type, 
                                    date:date,
                                    is_apply:is_apply })
                                    localStorage.setItem('temp_data',  JSON.stringify([user_id.toString()]));
                                    this.setState({selected_user_ary:[user_id]});
                                }}
                                >
                                <div className="row">
                                    <div className="col-3" >
                                        <div className="left-div" style={{borderColor:color}}>
                                            <small className="mm">{moment(date, "YYYY-MM-DD").format("MMM")}</small>
                                            <p className="dd">{moment(date, "YYYY-MM-DD").format("DD")}</p>
                                        </div>
                                    </div>
                                    <div className="col-6 pr-0 border-left-1 center-div">
                                        <i className="fa fa-check-square" aria-hidden="true" style={{ color : (is_publish === 1) ? '#00CC00' : 'gray' }}></i>
                                        <div>{start} - {end}</div>
                                        <div style={{color:color}}>{name}</div>
                                        {(user_id === 0) ? <span className="lable-openshift">{t('lang.shift_sc_open_shift') }</span> : ''} 
                                        {(is_apply === 1) && (user_id === 0) ? <span className="applied-shift">{t('lang.shift_sc_applied')}</span> : ''}
                                    </div>
                                    <div className="col-3 last-div center">
                                        <i className="la la-angle-right"></i>
                                    </div>
                                </div>
                                        </Link>
                            </div>
                            : '' }</div>
                            ))}
                        </div>
                    : '' }


                    {(this.state.shift_type === 'all_shift') ?        
                        <div style={{marginTop:20}}>
                            {this.state.total_all_shift < 0 ? <p className="text-center">{t('lang.common_text_loading') }</p> : '' }
                            {this.state.total_all_shift === 0 ? <p className="text-center"> {t('lang.shift_sc_no_shift_available')}</p> : '' }
                            {this.state.all_shift_data.map(({ user_id, full_name,image, assignment_id, assignment_name,color,day, start,end, is_publish,notes,shift_id,schema_child_id,breaks,overtime, salary_amt,salary_type,nextShiftTotal,index}) => (
                            <div className="single-goal" key={Math.random()} >
                                <div className="row">
                                    <div className="col-3 center" >
                                        <div className="left-div" style={{borderColor:color}}>
                                        <img src={image} alt="img" />
                                        </div>
                                    </div>
                                    <div className="col-6 pr-0 border-left-1 center-div">
                                        <h6 className="text-overflow">{full_name}</h6>
                                        <div>{moment(start, "YYYY-MM-DD HH:mm").format("HH:mm")} - {moment(end, "YYYY-MM-DD HH:mm").format("HH:mm")}</div>
                                        <div style={{color:color}}>
                                           <span> <i className="fa fa-check-square" aria-hidden="true" style={{ color : (is_publish === 1) ? '#00CC00' : 'gray' }}></i> </span>
                                           <span> {assignment_name}</span>
                                        </div>
                                    </div>
                                    <div className="col-3 border-left-1 last-div" style={{fontSize:12}}>
                                        <p><small>{t('lang.shift_sc_next_shift')}</small></p>
                                        <div className="circle center">{nextShiftTotal}</div>
                                    </div>
                                </div>
                            </div>
                            ))}
                        </div>
                    : '' }


{/* START ABSENCE HERE */}

                        <div style={{marginTop:20}}>
                            <h6 className="title">{t('lang.shift_sc_absence_of_the_day')}</h6>
                            {this.state.absences.length == 0 ? 
                                <p className="text-center"> {t('lang.message__no_record_available')} </p> : ''}
                            {/* HERE START */}

                            {this.state.absences.map(({ assignmentId, full_name, image, color, font_color, id, is_publish, notes, ordering ,overtime, resourceId, salary_amt, salary_type, schemaId, schema_child_id, start,  end, title, index}) => (
                            <div className="single-goal" key={Math.random()} >
                                
                                <div className="row">
                                    <div className="col-3 center" >
                                        <div className="left-div" style={{borderColor:color}}>
                                        <img src={image} alt="img" />
                                        </div>
                                    </div>
                                    <div className="col-6 pr-0 border-left-1 center-div" 
                                     >
                                        <h6 className="text-overflow">{full_name}</h6>
                                        <div>{moment(start, "YYYY-MM-DD HH:mm").format("DD-MMM-YYYY")} - {moment(end, "YYYY-MM-DD HH:mm").format("DD-MMM-YYYY")}</div>
                                        <div style={{color:color}}>
                                           <span> <i className="fa fa-check-square" aria-hidden="true" style={{ color : (is_publish === 1) ? '#00CC00' : 'gray' }}></i> </span>
                                           <span> {title}</span>
                                        </div>
                                    </div>

                                </div>
                            </div>
                            ))}
                            {/* HERE END */}
                        </div>

                    {/* END ABSENCE HERE */}

                </div>

                    

                {/* transaction End */}
            {(localStorage.getItem('user_type') !== 'user') ? 
                <Link to={'#'} className="add-btn-right" 
                data-toggle="modal" data-target="#add-shift-modal"
                onClick={()=>{
                  this.setState({
                    is_publish:1,
                    shift_id : '',
                    selected_user : this.props.match.params.id,
                    selected_user_ary:[],
                    assignment_id : '',
                    assignment_color : '#ced4da',
                    start:'',
                    end:'',
                    day : '',
                    note:'',
                    overtime: '',
                    salary_amt:'',
                    salary_type: 2,
                    breaks:'',
                    shareholders: [
                       {    from_time:"",
                            to_time: ""
                      }]})
                    localStorage.setItem('temp_data',  JSON.stringify([(this.props.match.params.id).toString()]));
                    this.setState({selected_user_ary:[this.props.match.params.id]});
                }}
                >
                    <i className="las la-plus"></i>
                </Link>
                : ''}
    
                {/* Footer start */}
                <div className="footer-area">
                    <div className="container">
                        <div className="footer-bottom text-center">
                            <div className="row center">
                               <div className="col-8 offset-2">
                                    <div><span></span></div>
                                </div>
                                <div className="col-2">
                                {(localStorage.getItem('user_type') !== 'user') ?
                                    <Link className="home-clicked" to={'/shift-userlist'}>
                                        <i className="fa fa-reply" />
                                    </Link>
                                : 
                                    <Link className="home-clicked" to={'/'}>
                                        <i className="fa fa-home" />
                                    </Link>
                                }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* Footer End */}

            {/* Check in popip end  */}
                <CheckinPopup setCheckInStatus = {this.changeCheckIn}  checkinoutScreen="time" p_userid={(localStorage.getItem('user_type') !== 'user') ? this.props.match.params.id : localStorage.getItem('userid')}/>
            {/* Checkin popup end  */}

            {/*  add-shift-modal start */}
            <div id="add-shift-modal" className="modal fade">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">{t('lang.shift_sc_shift')} {moment(this.state.date, "YYYY-MM-DD").format("DD MMM YYYY")}</h5>
                           
                            <div className="modal-close" data-dismiss="modal">
                                <i className="la la-times" />
                            </div>
                        </div>
                        <div className="modal-body">
                            <div className="action-sheet-content">
                                <div className="row mb-3">
                                <div className="col-5" style={{paddingRight:0}}>
                                    <div className="input-group">
                                        <input type="time" className="form-control form-control-lg"
                                        value={this.state.start} 
                                        onChange={e => { this.setState({start: e.target.value})}} 
                                        placeholder={t('lang.shift_sc_from_time')} />
                                    </div>
                                </div>
                                <div className="col-5" style={{paddingRight:0}}>
                                    <div className="input-group">
                                        <input type="time" className="form-control form-control-lg"
                                        value={this.state.end} 
                                        onChange={e => { this.setState({end: e.target.value})}} 
                                        placeholder={t('lang.shift_sc_to_time')} />
                                    </div>
                                </div>
                                <div className="col-2"> 
                                    <i className="las la-clock time-icon"></i>
                                </div>
                                </div> 

                                <div className="input-group mb-3">
                                    <select className="form-control form-control-lg"
                                        style={{borderLeft: '20px solid', borderColor: this.state.assignment_color}}
                                        value={this.state.assignment_id}
                                        onChange={e => { this.setState({assignment_id: e.target.value, assignment_color: e.target[e.target.selectedIndex].title})}}>
                                      <option>{t('lang.shift_sc_select_shift')}</option>
                                      {this.state.assignment_list.map(({ id,name, choose_absence,calculate_it_as }) => (
                                        <option value={id} title={choose_absence} key={Math.random()} >{name}</option>
                                      ))}
                                    </select>
                                </div>

                                <>{this.state.user_list.map((data,idx)=>(
                                    <div key={Math.random()}> 
                                        {this.state.selected_user_ary.some(item => data.id == item) ? 
                                        <div key={Math.random()} className="row" style={{background: '#FFFFFF', padding: 10,marginBottom: 5,textTransform: 'capitalize',fontSize: 20}}>
                                        <div className="col-8" >{data.first_name} {data.last_name}</div>
                                        <div className="col-4 text-right"> 
                                        <i onClick={e => {this.removeMultiUserId(data.id)} } className="fa fa-check-square" aria-hidden="true" style={{color: '#089953'}}></i> </div></div>
                                     : ''}
                                    </div>
                                ))}</>
                                <div className="input-group mb-3">
                                    <p className="link" data-toggle="modal" data-target="#add-employee-modal" ><i className="las la-plus"></i> {t('lang.shift_sc_add_employee')}</p>
                                </div>

                                {/* Basic Tabs */}
                                <div className="widget has-shadow">
                                    <div className="widget-body sliding-tabs">
                                        <ul className="nav nav-tabs" id="example-one" role="tablist">
                                            <li className="nav-item">
                                                <a className="nav-link active" id="base-tab-1" data-toggle="tab" href="#tab-1" role="tab" aria-controls="tab-1" aria-selected="true">{t('lang.timestamp_sc_note')}</a>
                                            </li>
                                            <li className="nav-item">
                                                <a className="nav-link" id="base-tab-2" data-toggle="tab" href="#tab-2" role="tab" aria-controls="tab-2" aria-selected="false">{t('lang.common_text_break')}</a>
                                            </li>
                                            <li className="nav-item">
                                                <a className="nav-link" id="base-tab-3" data-toggle="tab" href="#tab-3" role="tab" aria-controls="tab-3" aria-selected="false">{t('lang.shift_sc_overtime')}</a>
                                            </li>
                                            <li className="nav-item">
                                                <a className="nav-link" id="base-tab-4" data-toggle="tab" href="#tab-4" role="tab" aria-controls="tab-4" aria-selected="false">{t('lang.shift_sc_amount')}</a>
                                            </li>
                                        </ul>
                                        <div className="tab-content pt-3">
                                            <div className="tab-pane fade show active" id="tab-1" role="tabpanel" aria-labelledby="base-tab-1">
                                                <input type="text" className="form-control form-control-lg"
                                                value={this.state.note} 
                                                placeholder={t('lang.flex_sc_the_note_here')}
                                                onChange={e => { this.setState({note: e.target.value})}} />
                                            </div>

                                            <div className="tab-pane fade" id="tab-2" role="tabpanel" aria-labelledby="base-tab-2">
                                                    <div className="text-center pb-3">
                                                        <span onClick={this.handleAddShareholder} className="add_break">  
                                                            <i className="las la-plus"></i> {t('lang.timestamp_sc_add_break')}
                                                        </span>
                                                    </div>
                                                    {this.state.shareholders.map((shareholder, idx) => (
                                                        <div className="row mb-3" key={Math.random()}>
                                                            <div className="col-5" style={{paddingRight:0}}>
                                                                <div className="input-group">
                                                                    <input type="time" className="form-control form-control-lg"
                                                                    value={shareholder.from_time}
                                                                    onChange={this.handleShareholderNameChange(idx)}
                                                                     />
                                                                </div>
                                                            </div>
                                                            <div className="col-5" style={{paddingRight:0}}>
                                                                <div className="input-group">
                                                                    <input type="time" className="form-control form-control-lg"
                                                                    value={shareholder.to_time}
                                                                    onChange={this.handleShareholderNameChange1(idx)}
                                                                     />
                                                                </div>
                                                            </div>
                                                            <div className="col-2"> 
                                                                <i className="las la-times-circle clear-icon" onClick={this.handleRemoveShareholder(idx)}></i>
                                                            </div>
                                                        </div>    
                                                    ))}

                                            </div>
                                            <div className="tab-pane fade" id="tab-3" role="tabpanel" aria-labelledby="base-tab-3">
                                                <input type="number" className="form-control form-control-lg"
                                                value={this.state.overtime} 
                                                placeholder={t('lang.shift_sc_overtime_in_percentage')}
                                                onChange={e => { this.setState({overtime: e.target.value})}} />
                                            </div>
                                            <div className="tab-pane fade" id="tab-4" role="tabpanel" aria-labelledby="base-tab-4">
                                                <div className="form-check form-check-inline">
                                                  <input className="form-check-input" type="radio" id="inlineRadio1" value="1" name="salary_type" checked={ (this.state.salary_type === '1' || this.state.salary_type === 1 ) ? true : false} onChange={e => { this.setState({salary_type: e.target.value})}}/>
                                                  <label className="form-check-label" htmlFor="inlineRadio1">{t('lang.shift_sc_hourly')}</label>
                                                </div>
                                                <div className="form-check form-check-inline">
                                                  <input className="form-check-input" type="radio" id="inlineRadio2" value="2" name="salary_type" checked={ (this.state.salary_type === '2' || this.state.salary_type === 2 ) ? true : false} onChange={e => { this.setState({salary_type: e.target.value})}} />
                                                  <label className="form-check-label" htmlFor="inlineRadio2">{t('lang.shift_sc_shift')}</label>
                                                </div>
                                                <input type="number" className="form-control form-control-lg"
                                                value={this.state.salary_amt} 
                                                placeholder={t('lang.shift_sc_shift_amount')}
                                                onChange={e => { this.setState({salary_amt: e.target.value})}} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* End Basic Tabs */}

                                <div className="input-group mb-3">
                                    <span className="single-switch">
                                        <label className="switch">
                                            <input type="checkbox" 
                                            value="1"
                                            id="is_publish_add"
                                            checked={this.state.is_publish}
                                            onChange={e => { this.setState({is_publish: e.target.checked})}} 
                                            />
                                            <span className="slider round" />
                                        </label>
                                    </span>
                                    { (this.state.is_publish === '1' || this.state.is_publish === 1) ?
                                    <label className="label color-green" htmlFor="is_publish_add"> {t('lang.shift_sc_approved')}</label>
                                    : <label className="label color-gray" htmlFor="is_publish_add"> {t('lang.shift_sc_not_approved')}</label>
                                    }
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn-c btn-success btn-block mb-2" onClick={()=>{this.addShift()}}>{t('lang.modal_btn_save')}</button>
                        </div>
                    </div>
                </div>
            </div>

            {/*  edit-shift-modal start */}
            <div id="edit-shift-modal" className="modal fade">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">{t('lang.shift_sc_shift')} {moment(this.state.date, "YYYY-MM-DD").format("DD MMM YYYY")}</h5>
                            <div className="modal-close" data-dismiss="modal">
                                <i className="la la-times" />
                            </div>
                        </div>
                        <div className="modal-body">
                            <div className="action-sheet-content">
                                <div className="row mb-3">
                                <div className="col-5">
                                    <div className="input-group mb-1">
                                        <input type="time" className="form-control form-control-lg"
                                        value={this.state.start} 
                                        onChange={e => { this.setState({start: e.target.value})}} />
                                    </div>
                                </div>
                                <div className="col-5">
                                    <div className="input-group mb-1">
                                        <input type="time" className="form-control form-control-lg"
                                        value={this.state.end} 
                                        onChange={e => { this.setState({end: e.target.value})}} />
                                    </div>
                                </div>
                                <div className="col-2"> 
                                    <i className="las la-clock time-icon"></i>
                                </div>
                                </div> 


                                <div className="input-group mb-3">
                                    <select className="form-control form-control-lg"
                                        style={{borderLeft: '20px solid', borderColor: this.state.assignment_color}}
                                        value={this.state.assignment_id}
                                        onChange={e => { this.setState({assignment_id: e.target.value, assignment_color: e.target[e.target.selectedIndex].title})}}>
                                      <option>{t('lang.shift_sc_select_shift')}</option>
                                      {this.state.assignment_list.map(({ id,name, choose_absence,calculate_it_as }) => (
                                        <option value={id} title={choose_absence} key={Math.random()} >{name}</option>
                                      ))}
                                    </select>
                                </div>


                                <>{this.state.user_list.map((data,idx)=>(
                                    <div key={Math.random()}> 
                                        {this.state.selected_user_ary.some(item => data.id == item) ? 
                                        <div key={Math.random()} className="row" style={{background: '#FFFFFF', padding: 10,marginBottom: 5,textTransform: 'capitalize',fontSize: 20}}>
                                        <div className="col-8" >{data.first_name} {data.last_name}</div>
                                        <div className="col-4 text-right"> 
                                        <i onClick={e => {this.removeMultiUserId(data.id)} } className="fa fa-check-square" aria-hidden="true" style={{color: '#089953'}}></i> </div></div>
                                     : ''}
                                    </div>
                                ))}</>
                                <div className="input-group mb-3">
                                    <p className="link" data-toggle="modal" data-target="#add-employee-modal" ><i className="las la-plus"></i> {t('lang.shift_sc_add_employee')}</p>
                                </div>
                                
                                {/* Basic Tabs */}
                                <div className="widget has-shadow">
                                    <div className="widget-body sliding-tabs">
                                        <ul className="nav nav-tabs" id="example-one" role="tablist">
                                            <li className="nav-item">
                                                <a className="nav-link active" id="base-tab-11" data-toggle="tab" href="#tab-11" role="tab" aria-controls="tab-11" aria-selected="true">{t('lang.timestamp_sc_note')}</a>
                                            </li>
                                            <li className="nav-item">
                                                <a className="nav-link" id="base-tab-22" data-toggle="tab" href="#tab-22" role="tab" aria-controls="tab-22" aria-selected="false">{t('lang.common_text_break')}</a>
                                            </li>
                                            <li className="nav-item">
                                                <a className="nav-link" id="base-tab-33" data-toggle="tab" href="#tab-33" role="tab" aria-controls="tab-33" aria-selected="false">{t('lang.shift_sc_overtime')}</a>
                                            </li>
                                            <li className="nav-item">
                                                <a className="nav-link" id="base-tab-44" data-toggle="tab" href="#tab-44" role="tab" aria-controls="tab-44" aria-selected="false">{t('lang.absence_sc_amount')}</a>
                                            </li>
                                        </ul>
                                        <div className="tab-content pt-3">
                                            <div className="tab-pane fade show active" id="tab-11" role="tabpanel" aria-labelledby="base-tab-11">
                                                <input type="text" className="form-control form-control-lg"
                                                value={this.state.note} 
                                                placeholder={t('lang.flex_sc_the_note_here')}
                                                onChange={e => { this.setState({note: e.target.value})}} />
                                            </div>

                                            <div className="tab-pane fade" id="tab-22" role="tabpanel" aria-labelledby="base-tab-22">
                                                    <div className="text-center pb-3">
                                                        <span onClick={this.handleAddShareholder} className="add_break">  
                                                            <i className="las la-plus"></i> {t('lang.timestamp_sc_add_break')}
                                                        </span>
                                                    </div>
                                                    {this.state.shareholders.map((shareholder, idx) => (
                                                        <div className="row mb-3" key={Math.random()}>
                                                            <div className="col-5" style={{paddingRight:0}}>
                                                                <div className="input-group">
                                                                    <input type="time" className="form-control form-control-lg"
                                                                    value={shareholder.from_time}
                                                                    onChange={this.handleShareholderNameChange(idx)}
                                                                     />
                                                                </div>
                                                            </div>
                                                            <div className="col-5" style={{paddingRight:0}}>
                                                                <div className="input-group">
                                                                    <input type="time" className="form-control form-control-lg"
                                                                    value={shareholder.to_time}
                                                                    onChange={this.handleShareholderNameChange1(idx)}
                                                                     />
                                                                </div>
                                                            </div>
                                                            <div className="col-2"> 
                                                                <i className="las la-times-circle clear-icon" onClick={this.handleRemoveShareholder(idx)}></i>
                                                            </div>
                                                        </div>    
                                                    ))}

                                            </div>

                                            <div className="tab-pane fade" id="tab-33" role="tabpanel" aria-labelledby="base-tab-33">
                                                <input type="number" className="form-control form-control-lg"
                                                value={this.state.overtime} 
                                                placeholder={t('lang.shift_sc_overtime_in_percentage')}
                                                onChange={e => { this.setState({overtime: e.target.value})}} />
                                            </div>
                                            <div className="tab-pane fade" id="tab-44" role="tabpanel" aria-labelledby="base-tab-44">
                                                <div className="form-check form-check-inline">
                                                  <input className="form-check-input" type="radio" id="inlineRadio1" value="1" name="salary_type" checked={ (this.state.salary_type === '1' || this.state.salary_type === 1) ? true : false} onChange={e => { this.setState({salary_type: e.target.value})}}/>
                                                  <label className="form-check-label" htmlFor="inlineRadio1">{t('lang.shift_sc_hourly')}</label>
                                                </div>
                                                <div className="form-check form-check-inline">
                                                  <input className="form-check-input" type="radio" id="inlineRadio2" value="2" name="salary_type" checked={ (this.state.salary_type === '2' || this.state.salary_type === 2) ? true : false} onChange={e => { this.setState({salary_type: e.target.value})}} />
                                                  <label className="form-check-label" htmlFor="inlineRadio2">{t('lang.shift_sc_shift')}</label>
                                                </div>
                                                <input type="number" className="form-control form-control-lg"
                                                value={this.state.salary_amt} 
                                                placeholder={t('lang.shift_sc_shift_amount')}
                                                onChange={e => { this.setState({salary_amt: e.target.value})}} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* End Basic Tabs */}

                                <div className="input-group mb-3">
                                    <div className="form-check form-switch">
                                    <span className="single-switch">
                                        <label className="switch">
                                            <input type="checkbox" 
                                            value="1"
                                            id="is_publish_edit"
                                            checked={this.state.is_publish}
                                            onChange={e => { this.setState({is_publish: e.target.checked})}} 
                                            />
                                            <span className="slider round" />
                                        </label>
                                    </span>
                                    { (this.state.is_publish === '1' || this.state.is_publish === 1) ?
                                    <label className="label color-green" htmlFor="is_publish_edit"> {t('lang.shift_sc_approved')}</label>
                                    : <label className="label color-gray" htmlFor="is_publish_edit"> {t('lang.shift_sc_not_approved')}</label>
                                     }
                                     </div>
                                </div>
                            {(this.state.is_open_shift === true) ? '' : 
                                <div className="input-group">
                                    <button type="button" className="btn-c btn-warning btn-square" 
                                    onClick={()=>{
                                        Alert.confirm({
                                        position:'toast-top-full-width',
                                        message: t('lang.message_are_you_sure'),
                                        btn_yes: t('lang.btn_text_yes_do_it'),
                                        action: () =>{   
                                            this.setState({selected_user : 0});
                                            localStorage.setItem('temp_data', JSON.stringify(["0"]));
                                            this.setState({selected_user_ary:[0]});
                                            this.updateShift();
                                        }
                                    })
                                }}  >Move to avalable</button>
                                </div>
                            }    
                                <div className="input-group"
                                onClick={()=>{
                                        Alert.delete({
                                        position:'toast-top-full-width',
                                        message:t('lang.message_this_data_wont_be_retrievable_once_deleted_are_you_sure'),
                                        btn_yes:t('lang.btn_text_yes_do_it'),
                                        action: () =>{   
                                            this.deleteShift();
                                        }
                                    })
                                }}>
                                    <button type="button" className="btn-c btn-danger btn-square">{t('lang.shift_sc_delete_shift')}</button>
                                </div>
                                
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn-c btn-success btn-block mb-2" onClick={()=>{this.updateShift()}}>{t('lang.modal_btn_save')}</button>
                        </div>
                    </div>
                </div>
            </div>

            {/*  apply-shift-modal start */}
            <div id="apply-shift-modal" className="modal fade">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">{t('lang.shift_sc_shift')} {moment(this.state.date, "YYYY-MM-DD").format("DD MMM YYYY")}</h5>
                            <div className="modal-close" data-dismiss="modal">
                                <i className="la la-times" />
                            </div>
                        </div>
                        <div className="modal-body">
                            <div className="action-sheet-content">
                                <div className="row mb-3">
                                <div className="col-5">
                                    <div className="input-group mb-1">
                                        <input type="time" className="form-control form-control-lg"
                                        value={this.state.start} 
                                        readOnly={true} />
                                    </div>
                                </div>
                                <div className="col-5">
                                    <div className="input-group mb-1">
                                        <input type="time" className="form-control form-control-lg"
                                        value={this.state.end} 
                                        readOnly={true} />
                                    </div>
                                </div>
                                <div className="col-2"> 
                                    <i className="las la-clock time-icon"></i>
                                </div>
                                </div> 


                                <div className="input-group mb-3">
                                    <select className="form-control form-control-lg"
                                        style={{borderLeft: '20px solid', borderColor: this.state.assignment_color}}
                                        value={this.state.assignment_id} 
                                        readOnly={true} >
                                      <option>{t('lang.shift_sc_select_shift')}</option>
                                      {this.state.assignment_list.map(({ id,name, choose_absence,calculate_it_as }) => (
                                        <option value={id} title={choose_absence} key={Math.random()} >{name}</option>
                                      ))}
                                    </select>
                                </div>
                                
                                {/* Basic Tabs */}
                                <div className="widget has-shadow">
                                    <div className="widget-body sliding-tabs">
                                        <ul className="nav nav-tabs" id="example-one" role="tablist">
                                            <li className="nav-item">
                                                <a className="nav-link active" id="base-tab-11" data-toggle="tab" href="#tab-111" role="tab" aria-controls="tab-11" aria-selected="true">{t('lang.timestamp_sc_note')}</a>
                                            </li>
                                            <li className="nav-item">
                                                <a className="nav-link" id="base-tab-22" data-toggle="tab" href="#tab-222" role="tab" aria-controls="tab-22" aria-selected="false">{t('lang.common_text_break')}</a>
                                            </li>
                                            <li className="nav-item">
                                                <a className="nav-link" id="base-tab-33" data-toggle="tab" href="#tab-333" role="tab" aria-controls="tab-33" aria-selected="false">{t('lang.shift_sc_overtime')}</a>
                                            </li> 
                                            <li className="nav-item">
                                                <a className="nav-link" id="base-tab-44" data-toggle="tab" href="#tab-444" role="tab" aria-controls="tab-44" aria-selected="false">{t('lang.shift_sc_amount')}</a>
                                            </li>
                                        </ul>
                                        <div className="tab-content pt-3">
                                            <div className="tab-pane fade show active" id="tab-111" role="tabpanel" aria-labelledby="base-tab-11">
                                                <input type="text" className="form-control form-control-lg"
                                                value={this.state.note} 
                                                placeholder={t('lang.flex_sc_the_note_here')}
                                                readOnly={true} />
                                            </div>

                                            <div className="tab-pane fade" id="tab-222" role="tabpanel" aria-labelledby="base-tab-22">
                                                    {this.state.shareholders.map((shareholder, idx) => (
                                                        <div className="row mb-3" key={Math.random()}>
                                                            <div className="col-5" style={{paddingRight:0}}>
                                                                <div className="input-group">
                                                                    <input type="time" className="form-control form-control-lg"
                                                                    value={shareholder.from_time} readOnly={true}
                                                                     />
                                                                </div>
                                                            </div>
                                                            <div className="col-5" style={{paddingRight:0}}>
                                                                <div className="input-group">
                                                                    <input type="time" className="form-control form-control-lg"
                                                                    value={shareholder.to_time} readOnly={true}
                                                                     />
                                                                </div>
                                                            </div>
                                                            <div className="col-2"> 
                                                               
                                                            </div>
                                                        </div>    
                                                    ))}

                                            </div>

                                            <div className="tab-pane fade" id="tab-333" role="tabpanel" aria-labelledby="base-tab-33">
                                                <input type="number" className="form-control form-control-lg"
                                                value={this.state.overtime} 
                                                placeholder={t('lang.shift_sc_overtime_in_percentage')}
                                                readOnly={true} />
                                            </div>
                                            <div className="tab-pane fade" id="tab-444" role="tabpanel" aria-labelledby="base-tab-44">
                                                <div className="form-check form-check-inline">
                                                  <input className="form-check-input" type="radio" id="inlineRadio1" value="1" name="salary_type" checked={ (this.state.salary_type === '1' || this.state.salary_type === 1) ? true : false} readOnly={true} />
                                                  <label className="form-check-label" htmlFor="inlineRadio1">{t('lang.shift_sc_hourly')}</label>
                                                </div>
                                                <div className="form-check form-check-inline">
                                                  <input className="form-check-input" type="radio" id="inlineRadio2" value="2" name="salary_type" checked={ (this.state.salary_type === '2' || this.state.salary_type === 2) ? true : false} readOnly={true} />
                                                  <label className="form-check-label" htmlFor="inlineRadio2">{t('lang.shift_sc_shift')}</label>
                                                </div>
                                                <input type="number" className="form-control form-control-lg"
                                                value={this.state.salary_amt} 
                                                placeholder={t('lang.shift_sc_shift_amount')}
                                                readOnly={true} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* End Basic Tabs */}

                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn-c btn-success btn-block mb-2" 
                            onClick={()=>{
                                    Alert.confirm({
                                    position:'toast-top-full-width',
                                    message: t('lang.message_are_you_sure'),
                                    btn_yes: t('lang.btn_text_yes_do_it'),
                                    action: () =>{
                                        if(this.state.user_id === 0){
                                            this.applyFreeShift();
                                        }else{
                                            this.freeShift();
                                        }
                                    }
                                })
                            }}>{this.state.is_apply === 1 ? t('lang.shift_sc_giveaway') : t('lang.shift_sc_apply_for_shift')}</button>
                        </div>
                    </div>
                </div>
            </div>

            {/*  add-employee-modal start */}
            <div id="add-employee-modal" className="modal fade">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">{t('lang.shift_sc_select_employee')}</h5>
                            <div className="modal-close" data-dismiss="modal">
                                <i className="la la-times" />
                            </div>
                        </div>
                        <div className="modal-body">
                            {this.state.user_list.map(item=> (
                            <div key={Math.random()}  className="row" style={{background: '#FFFFFF', padding: 10,marginBottom: 5,textTransform: 'capitalize',fontSize: 20}}>
                            <label className="col-10" id={item.id} htmlFor={item.id+'_uchk'} style={{marginBottom:0}}>{item.first_name} {item.last_name} </label>
                            <div className="col-2 text-right" > 
                                <input type="checkbox" name="user_idsary"
                                id={item.id+'_uchk'} value={item.id} title={item.first_name +' '+item.last_name}
                                onChange={e => { this.handleChange(e)  }} 
                                checked={this.handleCheckSelectedUserExistOrNot(item.id)} />
                            </div></div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>

            {/*  calendar-modal start */}
            <div id="calendar-modal" className="modal fade" style={{top: 0,bottom: 'auto'}}>
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">{t('lang.shift_sc_shift')} {moment(this.state.date, "YYYY-MM-DD").format("DD MMM YYYY")}</h5>
                           
                            <div className="modal-close" data-dismiss="modal">
                                <i className="la la-times" />
                            </div>
                        </div>
                        <div className="modal-body">
                            <div className="action-sheet-content">
                                <div className="input-group">
                                    <input type="date" value={this.state.date} className="datecalander form-control form-control-lg"
                                    onChange={e => { this.setState({date: e.target.value}); this.getAllShif(e.target.value); window['modalClose'](); }}/>
                                </div>
                            </div>  
                        </div>  
                    </div>  
                </div>     
            </div>
            </>
        );
    }
}

export default withTranslation('common')(ShiftUser);